import styled from 'styled-components'
import media from 'src/styles/media'

export const ProjectSliderWrapper = styled.section `
    position: relative;
    left: 0;
    height: auto;
    width: 100%;
    z-index: 5;
    margin: 30px 0 40px 0;
    max-width: 100%;

    ${media.lessThan('sm')`
        margin-top: 0;
    `}

    .slick-list{
        overflow: visible !important;
    }
    
    .slick-slide{
        & > div {
            pointer-events: none;
            cursor: pointer;
            padding: 20px;
        }
    }
    
    .slick-dots{
        display: block;
        position: relative;
        margin-top: 20px;

        ${media.lessThan('md')`
          margin-top: 0;
        `}

        li{
            width: 11px;
            height: 11px;
            transition: width 0.4s;
        }

        button{
            display: block;
            width: 100%;
            height: 100%;
            background-color: #aaa7e6;
            border-radius: 50%;
            transition: all 0.4s;

            &:before{
                display: none;
            }


        }

        .slick-active{
            width: 44px;

            button{
                background-color: var(--dark);
                border-radius: 5px;
            }
        }

    }
`

export const ProjectSliderItem = styled.article `
    position: relative;
    box-shadow: 3px 4px 20px rgba(0,0,0,.2);
    border-radius: 15px;
    width: 100%;
    height: 400px;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.4s;
    z-index: 2;

    .slick-slide.slick-center{
        overflow: visible !important;
    }

    .slick-slide.slick-center &{
        transform: scale(1.2);
        z-index: 3;
    }

    ${media.lessThan('md')`
        height: 270px;
    `}

    ${media.lessThan('sm')`
        height: 180px;
    `}
`

export const ProjectSliderItemImage = styled.img`
    width: 100%;
    height: 100%;
    transition: all 0.4s;
    object-fit: cover;

    ${ProjectSliderItem}:hover &{
        transform: scale(1.1);
    }
`